module.exports = __webpack_public_path__ + "assets/img/8_1535_big.299db75e.jpg";